export const PLATFORM_OPTIONS = ['MOBILE', 'WEB', 'ADMIN'] as const;

export type Platform = (typeof PLATFORM_OPTIONS)[number];

export type PlatformConfig = {
  enabled: boolean;
  overrideDiscount: boolean;
  discount: number | null;
  '@id': string | null;
};

export type PlatformsState = {
  [platform in Platform]: PlatformConfig;
};

export const buildEmptyPlatformsState = (): PlatformsState =>
  PLATFORM_OPTIONS.reduce(
    (acc, platform) => ({
      ...acc,
      [platform]: {
        enabled: false,
        overrideDiscount: false,
        discount: null,
        '@id': null,
      },
    }),
    {} as PlatformsState
  );
